@if ((spinnerTimer$ | async) !== 0 || loading) {
  <ion-spinner name="crescent" appSafariAnimate></ion-spinner>
}
